<template>
  <div>
    <el-image v-if="render" fit="contain" :src="urlNew" @error=actionRetry()>
      <div slot="error">
        <el-image v-if="retry" fit="contain" :src="urlRetry"></el-image>
      </div>
    </el-image>
  </div>
</template>

<script>
export default {
  name: "ImageRefresh",
  props: ["url"],
  data() {
    return {
      render: false,
      urlNew: "",
      retry: false,
      urlRetry:"",
    };
  },
  methods: {
    actionRetry() {
      setTimeout(() => {
        this.urlRetry = this.url + "?" + new Date().getTime();
        this.retry = true;
      }, 2000);
    }
  },
  mounted() {
    setTimeout(() => {
      this.render = true;
      this.urlNew = this.url + "?" + new Date().getTime();
    }, 500);
  }
};
</script>

<style scoped>

</style>